export default class FormationDto {
  id;
  type;
  duree;
  nbInsertion;
  nbInsertionHorsInsertion;
}
